import type { FC } from 'react';
import styled from 'styled-components';
import { Text } from '@visx/text';
import { InformationSolid } from '@simplywallst/ui-core/icons';
import type { TextProps } from '@/thirdparty/@vx/text';

interface Props extends TextProps {
  bold?: boolean;
  highlight?: boolean;
}

const TitleTextComponent: FC<Props & TextProps> = ({
  children,
  bold,
  highlight,
  ...rest
}) => <Text {...(rest as any)}>{children}</Text>;

export const LabelText = styled(TitleTextComponent)<Props>`
  tspan {
    ${({ theme, bold }) =>
      bold ? theme.typography.xSmallStrong : theme.typography.xSmall}
    fill: ${({ theme, highlight }) =>
      highlight ? theme.color.chart03 : theme.color.white};
  }
`;

export const Info = styled(InformationSolid)`
  opacity: 0.5;
  > * {
    fill: ${({ theme }) => theme.color.white};
  }
`;

export const LabelWrapper = styled('svg')`
  overflow: visible;
`;
